module.exports = __webpack_public_path__ + "static/media/Under Contruction.3052bb50.svg";